/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { useEffect, useState } from "react";

import {
  AirPlayAvailability,
  usePlayerController,
} from "../../../../../BasePlayer";

declare global {
  interface Window {
    WebKitPlaybackTargetAvailabilityEvent: () => void;
  }
}

export const useAirPlay = () => {
  const { player } = usePlayerController();
  const [availability, setAvailability] = useState<AirPlayAvailability>();
  const [isCasting, setIsCasting] = useState(false);
  const hasAirPlaySupport = !!window.WebKitPlaybackTargetAvailabilityEvent;
  const canCast = availability === AirPlayAvailability.AVAILABLE;

  useEffect(() => {
    if (hasAirPlaySupport) {
      const unsubscribeAvailability = player.onAirPlayAvailabilityChange(
        (availability) => {
          setAvailability(availability);
        },
      );
      const unsubscribeStatus = player.onAirPlayStatusChange((isCasting) => {
        setIsCasting(isCasting);
      });

      return () => {
        unsubscribeAvailability();
        unsubscribeStatus();
      };
    }
  }, [hasAirPlaySupport, player]);

  const toggleAirPlay = () => {
    player.toggleAirPlay();
  };

  return {
    hasAirPlaySupport,
    isCasting,
    canCast,
    toggleAirPlay,
  };
};
